import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetSignoutResponse } from './types';

export const getSignout = async (lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/signout?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetSignoutResponse>;
	})
	.catch((error) => {
		console.error('Profile request error: ', error);
		throw error;
	});
};
